import type { ReactNode } from 'react'

import cn from 'clsx'

type Props = {
  children: ReactNode
  color: string
}

export default function Skittle({ children, color }: Props) {
  const isHexColor = /^#([A-Fa-f0-9]{3}|[A-Fa-f0-9]{6})$/.test(color)

  if (isHexColor) {
    return (
      <span
        style={{
          color: color,
          backgroundColor: `${color}20`
        }}
      >
        {children}
      </span>
    )
  }

  return (
    <span
      className={cn({
        'bg-blue-100/80 text-blue-700 dark:bg-blue-800/80 dark:text-blue-300': color === 'blue',
        'bg-green-100 text-green-700 dark:bg-green-800/80 dark:text-green-300': color === 'green',
        'bg-orange-100/80 text-orange-700 dark:bg-orange-800/70 dark:text-orange-200': color === 'orange',
        'bg-purple-100 text-purple-700 dark:bg-purple-800/80 dark:text-purple-200': color === 'purple',
        'bg-red-100 text-red-700 dark:bg-red-900 dark:text-red-400': color === 'red',
        'bg-yellow-100/70 text-yellow-700 dark:bg-yellow-800 dark:text-yellow-300': color === 'yellow'
      })}
    >
      {children}
    </span>
  )
}

Skittle.scheme = {
  render: 'Skittle',
  attributes: {
    color: { type: String, required: true }
  },
  children: ['span']
}
